import { Eye, Check } from 'lucide-react';
import {
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuItem,
} from '@/components/ui/dropdown-menu';
import { useImpersonation, ViewAsProfile, getProfileDisplayName } from '@/contexts/ImpersonationContext';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

const profiles: ViewAsProfile[] = [
  'visitor',
  'subscriber_basic',
  'subscriber_essential',
  'subscriber_enterprise',
  'admin',
];

export const ImpersonationSelector = () => {
  const { canImpersonate, viewAs, setViewAs, resetView } = useImpersonation();

  if (!canImpersonate) return null;

  return (
    <DropdownMenuSub>
      <Tooltip>
        <TooltipTrigger asChild>
          <DropdownMenuSubTrigger className="cursor-pointer">
            <Eye className="mr-2 h-4 w-4" />
            Visualizar como
          </DropdownMenuSubTrigger>
        </TooltipTrigger>
        <TooltipContent side="left">
          Visualização apenas para conferência da experiência.
          <br />
          Você continua como Superadmin.
        </TooltipContent>
      </Tooltip>
      <DropdownMenuSubContent>
        {/* Opção para voltar ao normal */}
        <DropdownMenuItem
          onClick={resetView}
          className="cursor-pointer"
        >
          {!viewAs && <Check className="mr-2 h-4 w-4" />}
          {viewAs && <span className="mr-2 w-4" />}
          <span className={!viewAs ? 'font-medium' : ''}>Superadmin (real)</span>
        </DropdownMenuItem>
        
        <div className="my-1 h-px bg-border" />
        
        {profiles.map((profile) => (
          <DropdownMenuItem
            key={profile}
            onClick={() => setViewAs(profile)}
            className="cursor-pointer"
          >
            {viewAs === profile && <Check className="mr-2 h-4 w-4" />}
            {viewAs !== profile && <span className="mr-2 w-4" />}
            <span className={viewAs === profile ? 'font-medium' : ''}>
              {getProfileDisplayName(profile)}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
};
